"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateOptins = void 0;
class UpdateOptins {
    constructor(profileService) {
        this.profileService = profileService;
    }
    execute(request) {
        return this.profileService.updateOptins(request);
    }
}
exports.UpdateOptins = UpdateOptins;
